import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTableCellHeader]',
  standalone: true,
})
export class TableCellHeaderDirective {
  public readonly templateRef = inject(TemplateRef);

  public appTableCellHeaderKey = input.required<string>();
  public appTableCellHeaderCellWidth = input<string>();
}
